import request from '@/utils/request'

// 查询患者信息列表
export function listPatientInfo(query) {
  return request({
    url: '/biz/patient-info/list',
    method: 'get',
    params: query
  })
}

// 查询患者信息分页
export function pagePatientInfo(query) {
  return request({
    url: '/biz/patient-info/page',
    method: 'get',
    params: query
  })
}

// 查询患者信息详细
export function getPatientInfo(data) {
  return request({
    url: '/biz/patient-info/detail',
    method: 'get',
    params: data
  })
}

// 新增患者信息
export function addPatientInfo(data) {
  return request({
    url: '/biz/patient-info/add',
    method: 'post',
    data: data
  })
}

// 修改患者信息
export function updatePatientInfo(data) {
  return request({
    url: '/biz/patient-info/edit',
    method: 'post',
    data: data
  })
}

// 删除患者信息
export function delPatientInfo(data) {
  return request({
    url: '/biz/patient-info/delete',
    method: 'post',
    data: data
  })
}

